import * as actions from './productionCapacity/actions'
import * as mutations from './productionCapacity/mutations'
import * as getters from './productionCapacity/getters'

import { dataProps } from './productionCapacity/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/productionCapacity.js